const HeaderScroll = {
  addEventListeners() {
    let lastScrollTop = 0;

    window.addEventListener('scroll', () => {
      this.setScrollHeader();

      if (this.st > lastScrollTop) {
        this.header.classList.add('header-scrolled');
      } else {
        this.header.classList.remove('header-scrolled');
      }

      lastScrollTop = this.st <= 0 ? 0 : this.st;
    }, false);
  },

  init() {
    this.st = window.pageYOffset || document.documentElement.scrollTop;
    this.setScrollHeader();
    this.addEventListeners();
  },

  setScrollHeader() {
    this.st = window.pageYOffset || document.documentElement.scrollTop;

    if (this.st === 0) {
      this.header.classList.add('header-top');
    } else {
      this.header.classList.remove('header-top');
    }
  },

  header: document.getElementById('header-2020'),
  st: window.pageYOffset || document.documentElement.scrollTop,
};

HeaderScroll.init();
